<template>
<div class="border rounded-bottom-30 rounded-top-30 bg--white">
    <span v-if="splitedExpertImageUrl">
        <a :href="[realUrl]" target="_blank" class="position-relative brand-poc-card-img">
            <img class="rounded-top-l-10 w-50 splited__image__left" :style="{'background-color':parentColorHexCode}" v-if="singlePoc.parentLogo" :src="singlePoc.parentLogo" />
            <img class="rounded-top-r-10 w-50 splited__image__right object-f-c" v-if="splitedExpertImageUrl" :src="splitedExpertImageUrl" />
       </a>
    </span>
    <span v-else>
        <a :href="[realUrl]" target="_blank" class="position-relative brand-poc-card-img">
            <img class="rounded-top-30 w-100" v-if="teaserImage" :src="teaserImage" />
            <img class="rounded-top-30 w-100" v-if="!teaserImage" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/loading_Image_top_image.svg" />
        </a>
    </span>

    <div class="card-body d-flex flex-column justify-content-between pb-1 poc-card-body-h px-3 py-2">
        <!-- parent logo and Name  and poc type-->
        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex justify-content-between w-100 min-h-28-p">

                <div class="parent-logo-wrapper mt-1 d-flex align-items-center">
                    <p v-if="singlePoc.parentName" class="m-0 font-weight-bold">{{cuteventName(singlePoc.parentName,24)}}</p>
                </div>
                <div v-if="poclabel" class="d-flex">
                    <div
                    :style="{'background-color':'rgba(220,220,220,0.4)' }" class="d-flex px-1-5 rounded align-items-center">
                        <p class="sm--text-poc small m-0 mr-1" v-if="poclabel" >{{poclabel}}</p>
                        <div v-if="poclabel && poclabel != 'Artikel'" class="live--svg d-flex py-1">
                            <img src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/play-Vector-dark.svg" alt="live" />
                        </div>
                        <div v-if="poclabel && poclabel == 'Artikel'" class="live--svg d-flex py-1">
                            <img src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/read-Vector-dark.svg" alt="read" />
                        </div>
                    </div>
                    <div v-if="singlePoc.language" class="ml-2 d-flex px-1-5 rounded align-items-center" :style="{'background-color':'rgba(220,220,220,0.4)' }">
                        <p class="sm--text-poc small m-0">{{singlePoc.language}}</p>
                    </div>
                </div>


            </div>
            <a :href="[realUrl]" target="_blank" class="position-relative brand-poc-card-img">
                <h4 class="font-weight-bold my-3 w-100 single-poc-t-mh h3 text-dark text-break" v-if="singlePoc.title">{{cuteventName(singlePoc.title,50)}}</h4>
            </a>
        </div>
        <div class="mb-3">
            <p v-if="singlePoc.subtitle" class="h6">
                {{singlePoc.subtitle}}
            </p>
            <div class="d-flex flex-wrap text-black-50 poc-expert-font-s-f poc-small-text">
                <template v-if="singlePoc.expertNames && singlePoc.expertNames.length">
                    <span> <span >By</span>&nbsp;</span>
                    <div class="flex-shrink-0" v-for="(expert, index) in singlePoc.expertNames.slice(0,2)" :key="index">
                        <div v-if="expert">{{expert}}<span v-if="singlePoc.expertNames.length > 1 && !last">,&nbsp;</span></div>
                    </div>
                    <div class="flex-shrink-0" v-if="singlePoc.expertNames && singlePoc.expertNames.length > 1">&nbsp; <span> and more</span></div>
                </template>
            </div>
            <div class="d-flex justify-content-between mt-1 align-items-center">
                <div v-if="singlePoc.duration && singlePoc.duration > 60">
                    <span :style="{ color: parentColorHexCode }" class="poc-small-text">{{Math.floor(singlePoc.duration/60)}} <span> min read</span> </span>
                </div>
                <div v-if="!isReadContent && displayDateTime && !singlePoc.duration && parentColorHexCode" :style="{ color: parentColorHexCode }" class="poc-small-text">{{displayDateTime}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import queryAndMutaionService from '@/services/queryAndMutaionService'

export default {
    name: "singlePocConference",
    created() {
        if (this.app === 'entwickler') {
            this.showItemBaseOfLangDe = true;
        }
    },
    data() {
        return {
            displayImage: false,
            isReadContent: false,
            displayDateTime: null,
            bgColor: '#007d8d',
            splitedExpertImageUrl: '',
            parentColorHexCode: this.singlePoc.parentColorHexCode || (this.showItemBaseOfLangDe ? '#00A19A' : '#7205d1'),
            teaserImage: '',
            poclabel: '',
            showItemBaseOfLangDe: false,
        };
    },
    props: {
        singlePoc: Object,
        realUrl: String,
        app: String,
    },
    mounted() {
        this.setImageForPoc();
        this.formatDates();
        this.setExpertImageUrl(this.singlePoc);
        this.getCorrectPocType();
    },
    methods: {
        formatDates() {
            if (this.singlePoc && this.singlePoc.isReadContent) {
                this.isReadContent = true;
            } else {
                if (!this.isReadContent && this.singlePoc.startDate && this.singlePoc.endDate &&
                    moment(this.singlePoc.startDate, 'DD-MM-YYYY HH:mm:ss').isValid() && moment(this.singlePoc.endDate, 'DD-MM-YYYY HH:mm:ss').isValid()) {
                    this.displayDateTime = moment(this.singlePoc.startDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LL') + ' | ' + moment(this.singlePoc.startDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LT') + ' - ' + moment(this.singlePoc.endDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LT');
                }
            }
        },
        getCorrectPocType() {
            if (this.singlePoc) {
                if (this.singlePoc.isReadContent && ((this.singlePoc.parentGenre && this.singlePoc.parentGenre != 'COURSE') || !this.singlePoc.parentGenre)) {
                    this.poclabel = 'Article';
                } else if (this.singlePoc.parentGenre && this.singlePoc.parentSchemaType && this.singlePoc.schemaType) {
                    this.poclabel = queryAndMutaionService.getCorrectPocType(this.singlePoc.parentGenre, this.singlePoc.parentSchemaType, this.singlePoc.schemaType);
                }
            }
            return;
        },

        setImageForPoc() {
            if (this.singlePoc.schemaType) {
                if (this.singlePoc.teaserImage) {
                    this.teaserImage = this.singlePoc.teaserImage;
                }
                if (!this.singlePoc.teaserImage) {
                    if (this.singlePoc.parentLogo) {
                        this.teaserImage = this.singlePoc.parentLogo;
                    } else if (!this.singlePoc.parentLogo) {
                        this.teaserImage = this.showItemBaseOfLangDe ? '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/entwickler__teasimage.svg' : '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/devmio.svg';
                    }
                }
            }
        },
        setExpertImageUrl(poc) {
            if (poc && poc.parentGenre && (poc.parentGenre == "RHEINGOLD" || poc.parentGenre == "FLEX_CAMP" || poc.parentGenre == "CAMP")) {
                if (poc && poc.experts && poc.experts.length && poc.experts[0] && poc.experts[0].image) {
                    this.splitedExpertImageUrl = poc.experts[0].image;
                } else {
                    this.splitedExpertImageUrl = 'https://redsys-prod.s3.eu-west-1.amazonaws.com/mustermann_max_ek_1558014709503_xxxx.png'
                }
            }

        },

        cuteventName(eventName,count) {
            if (eventName && eventName.length > count) {
                eventName = eventName.slice(0, count) + "...";
            }
            return eventName;
        }

    },
};
</script>

<style lang="css" scoped>
.brand-poc-card-img img {
    height: 210px;
    width: 100%;
}

.poc-card-body-h {
    min-height: 184px;
    width: 100%;
}

.parent-logo-wrapper img {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
    margin-right: 5px;
    padding: 0.5px;

}

.parent-logo-wrapper p {
    font-size: 12px;
}

.poc-expert-font-s-f {
    font-size: 12px;
    font-family: sans-serif;
    height: 30px;
}

.live--svg {
    margin-left: 0.35rem;
}

.sm--text-poc {
    text-align: center;
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.min-h-28-p {
    min-height: 28px;
}

.min-h-28-p div {
    height: 20px;
}

.single-poc-t-mh {
    min-height: 71px;
}

.poc-small-text {
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.small {
    font-size: 7px;
}

.border-top-30,
.rounded-top-30 {
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
}

.border-bottom-30,
.rounded-bottom-30 {
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
}

.d-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
}

.justify-content-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
}

.justify-content-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
}

.w-50 {
    width: 50% !important;
    height: 175px;
}

.object-f-c {
    object-fit: cover;
}

.min-h-28-p {
    min-height: 28px;
}

.w-100 {
    width: 100% !important;
}

.justify-content-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
}

.flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
}

.align-items-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
}

.min-h-28-p div {
    height: 20px;
}

.font-weight-bold {
    font-weight: 600 !important;
}

.parent-logo-wrapper p {
    font-size: 12px;
}

.position-relative {
    position: relative !important;
}

.single-poc-t-mh {
    min-height: 71px;
}

.text-dark {
    color: #343a40 !important;
}

.poc-small-text {
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.min-h-28-p div {
    height: 20px;
}

.live--svg {
    opacity: .7;
}
.px-1-5 {
    padding-left: .35rem !important;
    padding-right: .35rem !important;
}
.rounded-top-r-10{
	border-top-right-radius: 10px !important; 
}

.rounded-top-l-10{
	border-top-left-radius: 10px !important;
}
</style>
